import React from 'react';

import HomeBanner from './homeBanner';
import HomeTutorPoints from './homeTutorPoints';
import HomeAbout from './homeAbout';
import HomeTestimonials from './homeTestimonials';

const Home = () => {
    return (
        <div>

            {/* HomeBanner */}
            <HomeBanner />
            {/* HomeBanner close */}

            {/* HomeTutorPoints */}
            <HomeTutorPoints />
            {/* HomeTutorPoints close */}

            {/* HomeAbout */}
            <HomeAbout />
            {/* HomeAbout close */}

            {/* HomeTestimonials */}
            <HomeTestimonials />
            {/* HomeTestimonials close */}
            
        </div>
    );
};

export default Home;